import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useShowDetailedFundByIsin } from "@rentablo/api/apiv1";
import { HalfDonutChartWithData } from "@components/Chart/highcharts";
import { FundamentalsBlockLayout } from "../FundamentalsBlockLayout";

export interface Props {
  isin: string;
}

export const TopHoldings = ({ isin }: Props) => {
  const { t } = useTranslation();
  const { data, isFetching, isPending } = useShowDetailedFundByIsin(
    { isin, include: ["breakdowns"] },
    { enabled: Boolean(isin) }
  );

  const chartData = useMemo(() => {
    const holding = data?.breakdowns?.holding;
    if (!holding?.length) return undefined;
    return holding
      .map((h) => ({ name: h.holdingName, y: h.percent }))
      .sort((a, b) => b.y - a.y);
  }, [data?.breakdowns?.holding]);

  if (!chartData && !isFetching && !isPending) {
    return null;
  }

  return (
    <FundamentalsBlockLayout
      title={t("fundamentals.topHoldings")}
      isFetching={isFetching || isPending}
    >
      {chartData ? <HalfDonutChartWithData data={chartData} compact /> : null}
    </FundamentalsBlockLayout>
  );
};
